module.exports = __webpack_public_path__ + "static/media/header-3.17d68211.gif";